// 更改密码
import request from '@/api/request'

const changePass = (params) => {
  return request({
    url: '/api/v1/cuz/user/pwd/modify',
    method: 'POST',
    data: params,
    domain: 'mallUser'
  })
}

const getKey = (data) => {
  return request({
    url: '/api/v1/cuz/secret',
    method: 'POST',
    data,
    domain: 'mallUser'
  })
}

export default {
  changePass,
  getKey
}
